import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
import { Materia } from '../../sdk/@types';
import MateriaService from '../../sdk/services/MateriaService';

interface MateriaState {
  list: Materia.Materia[];
  materia?: Materia.Materia;
  fetching: boolean;
}

const initialState: MateriaState = {
  list: [],
  materia: { id: '1' },
  fetching: false,
};

export const getTodasAsMaterias = createAsyncThunk(
  'materia/getTodasAsMaterias',
  async () => await MateriaService.getMaterias()
);

export const getMateria = createAsyncThunk(
  'materia/getMateria',
  async (materia: Materia.Materia) => await MateriaService.getMateria(materia.id!)
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getTodasAsMaterias, getMateria);
  const error = isRejected(getTodasAsMaterias, getMateria);
  const loading = isPending(getTodasAsMaterias, getMateria);

  builder
    .addCase(getTodasAsMaterias.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(getMateria.fulfilled, (state, action) => {
      state.materia = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
